<template>
  <div>
    <div class="policy_main">
      <div class="text head">
        百运网尊重并保护所有使用百运网网络服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，百运网会按照本隐私权政策的规定使用和披露您的个人信息。但百运网将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，百运网不会将这些信息对外披露或向第三方提供。百运网会不时更新本隐私权政策。您在同意百运网络服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于百运网络服务使用协议不可分割的一部分。
      </div>
      <div class="title">
        一、适用范围
      </div>
      <div class="text">1、在您注册百运网帐号时，您根据百运网要求提供的个人注册信息（商家应法律法规要求需公示的企业名称及相关工商注册信息除外）；</div>
      <div class="text">2、在您使用百运网网络服务，或访问百运网平台网页时，百运网自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</div>
      <div class="text">3、百运网通过合法途径从商业伙伴处取得的用户个人数据。</div>
      <div class="subtitle">您了解并同意，以下信息不适用本隐私权政策：</div>
      <div class="text">1、您在使用百运网平台提供的搜索服务时输入的关键字信息；</div>
      <div class="text">2、百运网收集到的您在百运网发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情;</div>
      <div class="text">3、违反法律规定或违反百运网规则行为及百运网已对您采取的措施。</div>
      <div class="title">
        二、信息使用
      </div>
      <div class="text">1、注册账号</div>
      <div class="text">为完成创建账号，您需提供以下信息（统称“客户信息”）：您的手机号、账号名称/昵称、账号密码，我们将通过发送短信验证码来验证您的身份是否有效；您的信息将有助于我们为您提供优质的服务体验。</div>
      <div class="text">2、为您提供物流服务</div>
      <div class="text">在您下单寄件或您的信息作为收件人被提供时，百运或百运通过其授权的业务合作伙伴收集您的以下信息：寄件人及收件人的姓名、地址、联系方式和货件信息（统称“订单信息”），用于提交订单、生成物流运单、收件、仓储、运输、出口清关、进口清关、以及派送货件；根据相关法律要求，我们还收集您的企业信息（或身份证件信息）用于核验您的身份和进出口报关。</div>
      <div class="text">3、支付结算</div>
      <div class="text">在您下单后，您可以选择百运合作的第三方支付机构（如支付宝、微信支付以及银联、网联等支付通道，以下称“支付机构”）所提供的支付服务，我们需要将您的百运订单号与交易金额信息提供给这些支付机构以确认您的支付指令并完成支付。</div>
      <div class="text">如您申请发票，还需提供以下信息：发票抬头、纳税人识别号、收票人邮箱地址，以及您根据您的开票需求提供的更多信息，如购买方信息。</div>
      <div class="text">4、消息推送</div>
      <div class="text">我们收集您的设备信息，用于向您推送运件状态信息、支付状态信息及优惠券、促销信息。您可以在手机或其他设备的“设置”或在APP、微信公众号等进行免打扰设置。</div>
      <div class="text">5、间接获取、使用个人信息的情形</div>
      <div class="text">我们的产品集成神策数据，神策数据需要收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务（维持系统更好的服务运算），并通过地理位置校准报表数据准确性，提供基础反作弊能力。</div>
      <div class="text">我们可能从第三方（如微信、百度、抖音、qq）获取您授权共享的账户信息（头像、昵称），并在您同意本政策后将您的第三方账户与您的百运账户绑定，使您可以通过第三方账户直接登录并使用百运的服务。</div>
      <div class="text">如您通过非百运页面的第三方渠道下单寄件（如对接API系统），百运将从这些第三方渠道获取您的订单信息，包括收寄件人姓名、电话、地址和货件信息，以便为您提供收寄件相关服务。</div>
      <div class="text">在您向他人寄件时，请确保已获得收件人的相关授权，确保百运有权依据本政策处理收件人的个人信息。</div>
      <div class="text">如我们从我们的合作伙伴获取您的个人信息，我们将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</div>
      <div class="text">详细请查看SDK表格：<span class="sdk_table" @click="goSdkTable">百运网SDK数据采集表</span></div>
      <div class="text">6、存储有关敏感个人信息的提示</div>
      <div class="text">本产品实现将会开启您的设备访问权限，以上由您提供或我们收集您的信息中，可能包含您的个人敏感信息，包括：银行账号、虚拟财产信息、系统账号、邮箱地址及其有关的密码、电话号码、浏览记录、位置信息。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本《隐私政策》所述的目的和方式来处理。</div>
      <div class="text">7、软件安装系统信息</div>
      <div class="text">7.1 我们在您使用本产品过程中为了解产品适配性、识别账号异常状态，保证网络安全或运营安全，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</div>
      <div class="text">日志信息：当您使用本产品时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。包括您的登录账号、搜索查询内容、IP地址、网络环境、访问日期和时间及您访问的网页浏览记录、Push打开记录、停留时长、刷新记录、关注、收藏及分享。</div>
      <div class="text">设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（包括：IMEI、MAC、设备型号、操作系统版本、设备设置）、设备状态信息（包括：设备应用安装列表）设备所在位置相关信息（包括：IP 地址、GPS位置）</div>
      <div class="text">请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</div>
      <div class="text">7.2 您个人信息使用的规则</div>
      <div class="text">7.2.1 我们会根据本《隐私政策》的约定并为实现本产品功能对所收集的个人信息进行使用。</div>
      <div class="text">7.2.2 在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，有权对用户数据库进行分析并予以商业化的利用。</div>
      <div class="text">7.2.3 请您注意，您在使用本产品时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用产品期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。</div>
      <div class="text">7.2.4 我们会对产品使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示产品的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</div>
      <div class="text">7.2.5 当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</div>
      <div class="text">7.2.6 请您注意，如果我们要将您的信息用于本《隐私政策》中未载明的其他用途或额外收集未提及的其他信息，我们会另行事先请您同意。一旦您同意，该等额外用途将视为本《隐私政策》的一部分，该等额外信息也将适用本《隐私政策》。</div>
      <div class="text">7.3 我们将获取您的存储权限以便做一些文件功能，相关功能包括但不限于：个人/企业认证、下单时物流的相关资质、发票等。</div>
      <div class="title">
        三、信息披露声明
      </div>
      <div class="subtitle">在如下情况下，百运网将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</div>
      <div class="text">1、百运网不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和百运网（含百运网关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</div>
      <div class="text">2、为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与百运网合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。</div>
      <div class="text">3、根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</div>
      <div class="text">4、如您出现违反中国有关法律、法规或者百运网服务协议或相关规则的情况，需要向第三方披露；</div>
      <div class="text">5、百运网亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何百运网平台用户如从事上述活动，一经发现，百运网有权立即终止与该用户的服务协议。</div>
      <div class="text">6、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</div>
      <div class="text">7、在百运网平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，百运网有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</div>
      <div class="text">8、其它百运网根据法律、法规或者网站政策认为合适的披露。</div>
      <div class="title">
        四、信息存储和交换
      </div>
      <div class="text">百运网收集的有关您的信息和资料将保存在百运网及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或百运网收集信息和资料所在地的境外并在境外被访问、存储和展示。</div>
      <div class="title">
        五、Cookie的使用
      </div>
      <div class="text">1、在您未拒绝接受cookies的情况下，百运网会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的百运网平台服务或功能。百运网使用cookies可为您提供更加周到的个性化服务，包括推广服务。</div>
      <div class="text">2、您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的百运网网络服务或功能。</div>
      <div class="text">3、通过百运网所设cookies所取得的有关信息，将适用本政策。</div>
      <div class="title">
        六、信息安全
      </div>
      <div class="text">1、百运网帐号均有安全保护功能，请妥善保管您的用户名及密码信息。百运网将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。</div>
      <div class="text">2、在使用百运网网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是百运网用户名及密码发生泄露，请您立即联络百运网客服，以便百运网采取相应措施。</div>
      <div class="title">
        七、联系我们
      </div>
      <div class="subtitle">如果您对本隐私政策有任何疑问、意见或建议，可通过以下方式与我们联系：</div>
      <div class="text">深圳市百运科技有限公司</div>
      <div class="text">电 话：4009268156</div>
      <div class="text">常用办公地址：中国广东省深圳市福田区福虹路世贸广场B座2701</div>
      <div class="text">一般情况下，我们将在十五天内回复。</div>
    </div>
    <div class="agree">
      <button @click="agree">同意并继续</button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goSdkTable() {
      window.open('https://www.by56.com/news/6395.html')
    },
    agree() {
      this.$emit('agree', false)
    }
  },
}
</script>
<style lang="scss" scoped>
.policy_main {
  height: 368px;
  overflow: auto;
}
.policy_main::-webkit-scrollbar {
  /* 定义滚动条样式 */
  width: 4px;
}
.policy_main::-webkit-scrollbar-track {
  /*定义滚动条轨道 内阴影+圆角*/
  box-shadow: inset 0 0 0px #dddddd;
  border-radius: 2px;
}
.policy_main::-webkit-scrollbar-thumb {
  /*定义滑块 内阴影+圆角*/
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  background-color: #dddddd;
}
.text {
  margin-top: 8px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}
.title {
  height: 32px;
  line-height: 32px;
  margin: 16px 0 0;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.subtitle {
  margin-top: 8px;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
}
.head {
  text-indent: 2em;
}
.sdk_table {
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #0046b9;
  }
}
.agree {
  padding-top: 24px;
  display: flex;
  flex-direction: row-reverse;
  button {
    width: 96px;
    outline: none;
    height: 32px;
    cursor: pointer;
    background: #0046b9;
    border-radius: 4px;
    border: 1px solid #0046b9;
    transition: background 0.2s;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    &:hover {
      background: #2963c4;
      border: 1px solid rgba(0, 70, 185, 0);
      transition: background 0.2s;
    }
    &:active {
      background: #003a9b;
      border: 1px solid rgba(0, 70, 185, 0);
      transition: background 0.2s;
    }
  }
}
</style>